import React from 'react';
import $ from 'jquery';
import 'jquery-ui-bundle';
import autoBind from 'react-autobind';
import arrayUtils from '@common/helpers/array.utils';
import _ from 'lodash';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

//Context
import { withGridContext } from './grid.factory';

class GridOrdering extends React.Component {
  constructor(props) {
    super(props);
    this.refOrder = React.createRef();
    this.refOrderItem = React.createRef();
    this.refOrderDraggable = React.createRef();
    autoBind(this);
  }

  registerDrop(ref) {
    const { context } = this.props;
    const { hash } = context;
    const acceptHash = ".btn-small[data-hash='" + hash + "']";
    $(ref).droppable({
      drop: this.onReoder.bind(this),
      hoverClass: 'drop-hover-pills',
      accept: acceptHash,
      tolerance: 'pointer',
    });
  }

  registerDrag(ref) {
    $(ref).draggable({
      containment: '.ordering-container',
      distance: 20,
      revert: 'invalid',
      cursorAt: {
        top: -12,
        left: -20,
      },
      helper: function (event) {
        let columnHtml = $(event.target).data('label');
        return $('<span className="dragging-container">' + (columnHtml || '').trim() + '</span>');
      },
    });
  }

  componentDidMount() {
    const { context } = this.props;
    const { hash } = context;
    const acceptHash = ".dynamic-table-header[data-hash='" + hash + "']";
    $(this.refOrder.current).droppable({
      drop: this.onAdd.bind(this),
      hoverClass: 'ordering-container-hover',
      accept: acceptHash,
      tolerance: 'pointer',
    });
  }

  onRemove(item, index) {
    return (e) => {
      const { context } = this.props;
      const { order } = context;
      e.preventDefault();
      if (order.length == 1) {
        _alert.warning('É necessário ter pelo menos um campo para ordenação.');
      } else {
        context.setStateAndRefresh({ order: context.order.filter((x) => x.dataName != item.dataName) });
      }
    };
  }

  onAdd(e, ui) {
    const { context } = this.props;
    let element = ui.draggable;
    let index = $(element).data('index');
    let field = $(element).data('field');
    let name = $(element).data('name');

    let newOrder = {
      dataName: name,
      fieldName: field,
      order: 'A',
    };

    const { order, columns } = context;
    const existOrder = order.find((i) => i.dataName == newOrder.dataName);

    if (existOrder) {
      _alert.warning('Já existe essa coluna na lista de ordenação.');
      return;
    }

    const column = columns[index];
    if (column.removeOrder) {
      _alert.warning('Coluna não pode ser ordenada.');
      return;
    }

    context.setStateAndRefresh({ order: [...order, newOrder] });
  }

  onReoder(e, ui) {
    const { context } = this.props;
    let element = ui.draggable;
    let oldIndex = $(element).data('index');
    let newIndex = $(e.target).data('index');

    context.setStateAndRefresh({ order: arrayUtils.move(context.order, oldIndex, newIndex) });
  }

  onChangeOrder(item, index) {
    return (e) => {
      const { context } = this.props;
      e.preventDefault();
      const { order } = context;
      let filterOrder = order[index];
      filterOrder.order = filterOrder.order == 'A' ? 'D' : 'A';
      context.setStateAndRefresh({ order });
    };
  }

  onDefaultOrder(e) {
    e.preventDefault();
    const { context } = this.props;
    const { defaults } = context;
    context.setStateAndRefresh({ order: _.cloneDeep(defaults.order) });
  }

  render() {
    const { context, PlacementTooltip } = this.props;
    const { hash, order } = context;

    return (
      <div className="ordering-container" ref={this.refOrder}>
        <OverlayTrigger
          key={'top-Restaurar Ordenação Padrão'}
          placement={PlacementTooltip || 'bottom'}
          overlay={
            <TooltipBootstrap id={'tooltip-Restaurar Ordenação Padrão'}>
              <div className={'fontTooltip'}>{'Restaurar Ordenação Padrão'}</div>
            </TooltipBootstrap>
          }
        >
          <a onClick={this.onDefaultOrder} className="ordering-trash-undo">
            <i className="fa fa-undo" />
          </a>
        </OverlayTrigger>

        <label htmlFor="Ordenação:">Ordenação:</label>
        <ul>
          {order.map((item, i) => (
            <li key={i} ref={this.registerDrop} className="pointer" data-index={i}>
              <a
                ref={this.registerDrag}
                title={'Reposicionar Ordenação'}
                className="btn-small"
                data-index={i}
                data-hash={hash}
                data-label={item.fieldName}
                onClick={this.onChangeOrder(item, i)}
              >
                <span className="mr-2">
                  <i
                    className={`fa fa-caret-${item.order == 'A' ? 'up' : 'down'}`}
                    title={`${item.order == 'A' ? 'Ascendente' : 'Descendente'}`}
                  />
                </span>
                {item.fieldName}
              </a>
              <a className="btn-remove" onClick={this.onRemove(item, i)}>
                <i className="fa fa-times" title={'Remover da Ordenação'} />
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withGridContext(GridOrdering);
